module.exports = __webpack_public_path__ + "static/media/Price299Pro.c73ba28b.svg";